// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"d3a327c2","289":"5e4a2201","513":"3e2216a1","725":"b4b76b7d","810":"266ccf37"}[chunkId] + ".chunk.css";
};